{
  "hello": "你好 宝币",
  "nav": {
    "home": "首页",
    "convert": "闪兑",
    "c2c": "买卖币",
    "c2cTab": {
      "buy": "我要买",
      "sell": "我要卖"
    },
    "orderList": "订单",
    "orderTab": {
      "buy": "买币",
      "sell": "卖币",
      "fastTrack": "极速交易",
      "open": "进行中订单",
      "closed": "历史订单"
    },
    "my": "我的"
  },
  "hi": "Hi 👋",
  "introCustomerService": "您好！欢迎来到我们的客服中心。我们的专业团队随时为您提供帮助和支援。有什麽可以为您效劳的呢？请随时向我们提出您的问题或疑虑，我们将竭尽所能为您解决。",
  "startConversation": "开始另一场对话",
  "responseTime": "我们通常的回复时间",
  "fewMinutes": "几分钟",
  "sendUsMessage": "传信息给我们",
  "yourConversation": "您的对话",
  "cancel": "取消"
}
